import { CAMERA_LITE_URL, } from "app/env"

export function createCongestionIframeUrl (key: string) {
  return `${CAMERA_LITE_URL}?key=${key}&default=congestion&auto-updating=auto`
}
